import React from 'react';
import PropTypes from 'prop-types';

const Fill = ({ color }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
        <rect
            width="23"
            height="23"
            x=".5"
            y=".5"
            fill={color}
            stroke={color === 'rgb(255, 255, 255)' ? '#757575' : '#fff'}
            rx="2.5"
        />
    </svg>
);

Fill.defaultProps = {
    color: 'rgba(0, 0, 0, 0)',
};

Fill.propTypes = {
    color: PropTypes.string,
};

export default Fill;
